import { render, staticRenderFns } from "./AdditionalContributionInputs.vue?vue&type=template&id=8ead4922&"
import script from "./AdditionalContributionInputs.vue?vue&type=script&lang=js&"
export * from "./AdditionalContributionInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports